<!-- Collapsed Sidebar-->
@if (!isVisibleSidebar) {
    <div
        [@slideInOutLeft]
        class="sidebar-collapsed rounded-br-lg absolute top-0 left-0 flex flex-col items-center z-[99] gap-4 p-2"
    >
        <p-button
            pTooltip="Home"
            [showDelay]="500"
            icon="pi pi-home"
            [text]="true"
            [routerLink]="'/home'"
        />
        <p-avatar
            [label]="getUserInitial()"
            shape="circle"
            [pTooltip]="getTooltipText()"
            [showDelay]="500"
            tooltipPosition="bottom"
            (click)="showSignoutDialog()"
            class="cursor-pointer"
        />
        <p-button
            pTooltip="Expand"
            [showDelay]="500"
            icon="pi pi-chevron-right"
            [text]="true"
            (onClick)="onShowSidebar()"
        />
    </div>
}

<!-- Sidebar-->
<div
    class="absolute top-0 left-0 h-full z-50 flex flex-col"
    [class.p-sidebar-active]="isVisibleSidebar"
    [style.transform]="isVisibleSidebar ? 'translateX(0)' : 'translateX(-100%)'"
    [style.width]="'27rem'"
    [style.transition]="'transform ' + PANEL_ANIMATION_DURATION_MS + 'ms ease'"
>
    <div
        class="sidebar-controls bg-[var(--p-primary-800)] text-white w-full flex flex-col gap-2 p-4"
    >
        <div class="flex justify-between">
            <div class="flex items-center justify-center gap-2">
                <img
                    src="assets/traton/logos/svg/TRATON_logo_small.svg"
                    class="h-5 w-auto mb-1"
                    alt="Traton logo"
                />
                <a
                    class="flex font-bold text-lg leading-none no-underline text-[var(--p-warm-gray-50)]"
                    routerLink="/"
                    pTooltip="SesammTool 3 Home"
                    [showDelay]="500"
                >
                    SESAMMTOOL 3
                </a>
            </div>
            <div class="flex items-center gap-2">
                <p-avatar
                    shape="circle"
                    [label]="getUserInitial()"
                    [pTooltip]="getTooltipText()"
                    tooltipPosition="bottom"
                    [showDelay]="500"
                    (click)="showSignoutDialog()"
                    class="cursor-pointer"
                />
                <p-button
                    class="collapse-sidebar-btn"
                    icon="pi pi-chevron-left"
                    pTooltip="Collapse"
                    [showDelay]="500"
                    variant="text"
                    size="small"
                    (onClick)="onCollapseSidebar()"
                />
            </div>
        </div>

        <div class="w-full flex flex-col gap-2">
            <div class="grid grid-cols-12 gap-2 grid-nogutter w-full">
                <!-- Filter Configs button - only visible if user has edit role -->
                @if ((isReadOnlyUser$ | async) === false) {
                    <div class="col-span-6">
                        <p-button
                            icon="pi pi-filter"
                            label="{{
                                (selectedDiagramFilterConfig$ | async)?.name || 'Filter Configs'
                            }}"
                            size="small"
                            tooltipPosition="bottom"
                            styleClass="w-full"
                            [pTooltip]="'Filter Configs'"
                            [showDelay]="500"
                            (onClick)="isVisibleFilterDialog = true"
                        >
                        </p-button>
                    </div>
                }

                <!-- Workspace button -->
                <div [ngClass]="(isReadOnlyUser$ | async) === false ? 'col-span-6' : 'col-span-4'">
                    <p-button
                        icon="pi pi-truck"
                        label="{{ (configs$ | async)?.workspace?.name }}"
                        tooltipPosition="bottom"
                        styleClass="workspace-button w-full"
                        size="small"
                        [pTooltip]="'Workspace:\n' + (configs$ | async)?.workspace?.name"
                        [showDelay]="500"
                        (onClick)="workspaceDialog.open()"
                    >
                    </p-button>
                </div>

                <!-- Select CR button -->
                <div [ngClass]="(isReadOnlyUser$ | async) === false ? 'col-span-6' : 'col-span-4'">
                    <p-button
                        icon="pi pi-arrow-right-arrow-left"
                        label="{{ selectedCR?.name?.replace('SSCR-', '') || 'Select CR' }}"
                        tooltipPosition="bottom"
                        styleClass="w-full"
                        size="small"
                        [pTooltip]="'Change Request:\n' + (selectedCR?.name || 'Select CR...')"
                        [showDelay]="500"
                        (onClick)="onOpenCRDialog()"
                    >
                    </p-button>
                </div>

                <!-- SOP button -->
                <div [ngClass]="(isReadOnlyUser$ | async) === false ? 'col-span-6' : 'col-span-4'">
                    <p-button
                        icon="pi pi-calendar"
                        tooltipPosition="bottom"
                        styleClass="w-full"
                        size="small"
                        [label]="(configs$ | async)?.sopDate"
                        [pTooltip]="'SOP: ' + (configs$ | async)?.sopDate"
                        [showDelay]="500"
                        (onClick)="isVisibleSOPDialog = true"
                    >
                    </p-button>
                </div>
            </div>

            <p-panelmenu [model]="sidebarItems">
                <ng-template #item let-item>
                    <a
                        [routerLink]="item.routerLink"
                        (click)="
                            !item.routerLink && $event.preventDefault();
                            item.items && toggleToolsExpansion()
                        "
                        class="flex items-center justify-between cursor-pointer p-1"
                    >
                        <div class="flex items-center">
                            <span [class]="item.icon"></span>
                            <span [class]="'ml-3'">{{ item.label }}</span>
                        </div>
                        <div class="flex items-center gap-2 ml-auto">
                            @if (item.isLoading) {
                                <p-progress-spinner class="w-5! h-5!" strokeWidth="8" />
                            }
                            @if (item.badge && !item.isLoading) {
                                <p-badge [value]="item.badge" class="h-4" />
                            }
                            @if (item.showDisabledChip) {
                                <p-chip label="Disabled" icon="pi pi-exclamation-circle" />
                            }
                            @if (item.items) {
                                <i
                                    [class]="
                                        isToolsExpanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'
                                    "
                                    [pTooltip]="isToolsExpanded ? 'Collapse' : 'Expand'"
                                    [showDelay]="500"
                                ></i>
                            }
                        </div>
                    </a>
                </ng-template>
            </p-panelmenu>
        </div>
    </div>

    <div class="sidebar-content flex flex-col flex-1 overflow-hidden">
        <app-tree
            class="flex-1 overflow-y-auto overflow-x-hidden"
            (instanceSelected)="onInstanceSelected($event)"
        ></app-tree>
    </div>
</div>
<!-- Workspace Dialog-->
<app-workspace-dialog #workspaceDialog></app-workspace-dialog>

<!-- Select Filter Config Dialog -->
<p-dialog
    header="Select Filter Configs"
    [modal]="true"
    [dismissableMask]="true"
    [(visible)]="isVisibleFilterDialog"
    [style]="{ width: '25rem' }"
>
    <form (ngSubmit)="filterForm.valid && onApplyFilterConfig()">
        <div class="flex flex-row items-center gap-2">
            <app-dropdown-lazy
                class="flex-1"
                ngDefaultControl
                [formControl]="filterForm"
                [isLoading]="isFilterConfigsLoading"
                [optionLabel]="'name'"
                [optionValue]="'id'"
                [options]="diagramFilterConfigs"
                [hasMore]="false"
                [showDelete]="true"
                placeholder="Select filter config"
                [excludeDeleteIds]="[0]"
                (deleteEvent)="onDeleteFilterConfig($event.id)"
            ></app-dropdown-lazy>
            <p-button
                icon="pi pi-plus"
                [pTooltip]="'Create new filter config'"
                [showDelay]="500"
                tooltipPosition="bottom"
                (onClick)="createFilterConfigDialog.onOpen(); isVisibleFilterDialog = false"
            >
            </p-button>
        </div>

        <div class="flex justify-end pt-4">
            <p-button variant="text" label="Clear" (onClick)="onClearFilterConfig()" />
            <p-button
                label="Apply"
                [disabled]="filterForm.invalid"
                (onClick)="onApplyFilterConfig()"
            />
        </div>
    </form>
</p-dialog>

<!-- Create Filter Config Dialog-->
<app-create-filter-config-dialog
    #createFilterConfigDialog
    (save)="onCreateFilterConfig($event)"
></app-create-filter-config-dialog>

<!-- Change Request Dialog -->
<p-dialog
    header="Select Change Request"
    [modal]="true"
    [dismissableMask]="true"
    [(visible)]="isVisibleCRDialog"
    [style]="{ width: '25rem' }"
>
    <form (ngSubmit)="crForm.valid && updateCr()">
        <app-dropdown-lazy
            ngDefaultControl
            [formControl]="crForm"
            [isLoading]="isChangeRequestsLoading"
            [optionLabel]="'name'"
            [optionValue]="'key'"
            [options]="changeRequests"
            [hasMore]="changeRequestsHasMore"
            placeholder="Select change request"
            (loadMoreEvent)="onLoadMoreChangeRequests($event)"
            (searchEvent)="onSearchChangeRequests($event)"
        ></app-dropdown-lazy>

        <div class="flex justify-end pt-4">
            <p-button
                variant="text"
                label="Clear"
                [disabled]="crForm.invalid"
                (onClick)="onClearChangeRequest()"
            />
            <p-button label="Apply" [disabled]="crForm.invalid" (onClick)="updateCr()" />
        </div>
    </form>
</p-dialog>

<!-- SOP Dialog -->
<p-dialog
    header="Select SOP"
    [modal]="true"
    [dismissableMask]="true"
    [(visible)]="isVisibleSOPDialog"
    [style]="{ width: '25rem' }"
>
    <form (ngSubmit)="sopForm.valid && updateSop()">
        <p-inputMask
            [formControl]="sopForm"
            styleClass="w-full"
            #mask
            mask="9999-99"
            placeholder="2025-07"
            slotChar="YYYY-MM"
        />

        <div class="flex justify-end pt-4">
            <p-button label="Apply" [disabled]="sopForm.invalid" (onClick)="updateSop()" />
        </div>
    </form>
</p-dialog>
